import { takeLatest, put, call, select, take } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import {
  getEnrichedSchemasIfNeeded,
  getPaginatedEnrichedSchemasIfNeeded,
  getEnrichedSchemaKeys,
  getEnrichedSchemaIfNeeded,
  createEnrichedSchemaFromCurrent,
  activateOrDeactivateEnrichedSchema,
  updateEnrichedSchemaFromCurrent
} from './sagas';

import {
  CREATE_ENRICHED_SCHEMA,
  GET_ENRICHED_SCHEMAS,
  GET_PAGINATED_ENRICHED_SCHEMAS,
  GET_ENRICHED_SCHEMA_KEYS,
  GET_ENRICHED_SCHEMA,
  ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA,
  CREATING_ENRICHED_SCHEMA_SUCCEEDED,
  UPDATE_ENRICHED_SCHEMA,
  UPDATING_ENRICHED_SCHEMA_SUCCEEDED,
  getEnrichedSchema
} from './actions';

import { actions as UserActions } from '../user';

function* forceGetEnrichedSchema(action) {
  const schemaId = action.payload.uuid;
  if (schemaId) {
    yield put(getEnrichedSchema({ force: true, schemaId: schemaId }));
    yield put(push(`/enriched-schema/design/${schemaId}`));
  }
}

function* waitForUserReady() {
  const userReady = yield select(store => store.user.ready);
  if (!userReady) {
    yield take(UserActions.LOGIN_READY);
  }
}

function* EnrichedSchemaGetManySaga() {
  yield takeLatest(GET_ENRICHED_SCHEMAS, function*(action) {
    yield call(waitForUserReady);
    yield call(getEnrichedSchemasIfNeeded, action);
  });
}

function* PaginatedEnrichedSchemaGetManySaga() {
  yield takeLatest(GET_PAGINATED_ENRICHED_SCHEMAS, function*(action) {
    yield call(waitForUserReady);
    yield call(getPaginatedEnrichedSchemasIfNeeded, action);
  });
}

function* EnrichedSchemaGetSingleSaga() {
  yield takeLatest(GET_ENRICHED_SCHEMA, function*(action) {
    yield call(waitForUserReady);
    yield call(getEnrichedSchemaIfNeeded, action);
  });
}

function* EnrichedSchemaGetKeysSaga() {
  yield takeLatest(GET_ENRICHED_SCHEMA_KEYS, function*() {
    yield call(waitForUserReady);
    yield call(getEnrichedSchemaKeys);
  });
}

function* EnrichedSchemaActivateOrDeactivateSaga() {
  yield takeLatest(ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA, function*(action) {
    yield call(activateOrDeactivateEnrichedSchema, action);
  });
}

function* EnrichedSchemaCreateSaga() {
  yield takeLatest(CREATE_ENRICHED_SCHEMA, createEnrichedSchemaFromCurrent);
}

function* EnrichedSchemaUpdateSaga() {
  yield takeLatest(UPDATE_ENRICHED_SCHEMA, function*(action) {
    yield call(updateEnrichedSchemaFromCurrent, action);
  });
}

function* EnrichedSchemaCreateSuccessSaga() {
  yield takeLatest(CREATING_ENRICHED_SCHEMA_SUCCEEDED, forceGetEnrichedSchema);
}

function* EnrichedSchemaUpdateSuccessSaga() {
  yield takeLatest(UPDATING_ENRICHED_SCHEMA_SUCCEEDED, forceGetEnrichedSchema);
}

export default [
  EnrichedSchemaGetManySaga,
  PaginatedEnrichedSchemaGetManySaga,
  EnrichedSchemaGetKeysSaga,
  EnrichedSchemaGetSingleSaga,
  EnrichedSchemaCreateSaga,
  EnrichedSchemaActivateOrDeactivateSaga,
  EnrichedSchemaUpdateSaga,
  EnrichedSchemaCreateSuccessSaga,
  EnrichedSchemaUpdateSuccessSaga
];
